<template>
    <vs-button icon-pack="feather" icon="icon-plus" @click.stop="$emit('addDream')">{{title}}</vs-button>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: 'Create Dream'
    },
  },
}
</script>

